// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

// Create the context
const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(() => {
    return !!Cookies.get("token"); // Check for token directly
  });
  // Initialize login state based on the presence of a token
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setLoggedIn(true);
    }
  }, []); // Runs only once when the component mounts

  const login = () => {
    setLoggedIn(true);
    // Optional: Add logic to set token in cookies if not already set
  };

  const logout = () => {
    setLoggedIn(false);
    Cookies.remove("token"); // Remove token from cookies on logout
  };

  return (
    <AuthContext.Provider value={{ loggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
